<template>
    <v-container class="mx-auto">
        <v-layout row wrap>
            <v-flex xs12 md8>
                <material-card color="green lighten-3" title="Could You Have Prediabetes?" text="Complete your test">
                    <span class="headline">{{ currentTitle }}</span>
                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <SelectAge @change="setAge"></SelectAge>
                        </v-window-item>

                        <v-window-item :value="2">
                            Men are more likely than women to have undiagnosed diabetes; one reason may be that they are
                            less likely to see their doctor regularly
                            <SelectGender @change="setGender"></SelectGender>
                        </v-window-item>

                        <v-window-item :value="3">
                            The waist circumference, and blood pressure were significant factors for the Qatar
                            prediabetes
                            <SelectWomanWaist @change="setWaist" v-if="getGender()=='Woman'"></SelectWomanWaist>
                            <SelectManWaist @change="setWaist" v-if="getGender()=='Man'"></SelectManWaist>
                        </v-window-item>

                        <v-window-item :value="4">
                            The Systolic blood pressure measures the pressure in your blood vessels when your heart
                            beats.
                            <SystolicBloodPressure @change="setsistolicBP"></SystolicBloodPressure>
                        </v-window-item>

                        <v-window-item :value="5">
                            The Diastolic blood pressure measures the pressure in your blood vessels when your heart
                            rests between beats.
                            <DiastolicBloodPressure @change="setdiastolicBP"></DiastolicBloodPressure>
                        </v-window-item>

                        <v-window-item :value="6">
                            <v-card-text><h4>The combination of your weight and height lets us know your Body Mass Index
                                or BMI.
                                People with higher BMIs are at a higher risk</h4>
                                </p>
                                <span class="headline blue--text">How tall are you in m?</span>
                                <SelectHeight @change="setHeight"></SelectHeight>
                            </v-card-text>
                            <v-card-text>
                                <span class="headline blue--text">Please select your weight [kg].</span>
                                <SelectWeight @change="setWeight"></SelectWeight>
                            </v-card-text>
                        </v-window-item>

                        <v-window-item :value="7">

                            <v-card-text class="display-2 blue--text text--darken-3"> {{ info.title }}</v-card-text>
                            <v-card-text class="title blue--text text--darken-3"> {{ info.msg}}</v-card-text>

                            <v-flex xs12 md2>
                                <v-card v-if="info.risk=='very low'" class="teal accent-3 pa-2" outlined tile>
                                    <span v-bind:class="info.risk==='very low' ? 'title white--text': 'black--text'">Based on your results, you are at very low risk for prediabetes. Keep up the good work!</span>
                                </v-card>
                            </v-flex>



                            <v-flex xs12 md2>
                                <v-card v-if="info.risk=='moderate'" class="orange lighten-4  pa-2" outlined tile>
                                 <span v-bind:class="info.risk==='moderate' ? 'title white--text': 'black--text'">Based on your results, you may be at the border of having prediabetes, but only your doctor can diagnose it for sure.
                                        Ask your doctor for a simple blood test to confirm  your score</span>
                                </v-card>
                            </v-flex>

                            <v-flex xs12 md3>
                                <v-card v-if="info.risk=='high'" class=" red darken-1 pa-2 pa-2" outlined tile>
                                <span v-bind:class="info.risk==='high' ? 'title white--text': 'black--text'">Based on your results, you are likely at high risk for prediabetes, but only your doctor can diagnose it for sure.
                                            Ask your doctor for a simple blood test to confirm your score.</span>
                                </v-card>
                            </v-flex>

                            <v-flex xs12 md3>
                                <v-card v-if="info.risk=='very high'" class="red darken-1 pa-2" outlined tile>
                                <span v-bind:class="info.risk==='very high' ? 'title white--text': 'black--text'">Based on your results, you are likely at very high risk for prediabetes, but only your doctor can diagnose it for sure.
                                    Ask your doctor for a simple blood test to confirm your score.</span>
                                </v-card>
                            </v-flex>


                            <v-card v-if="step==7">
                                <v-layout row class="d-flex justify-content-between" wrap>
                                    <v-flex xs12 md2>
                                        <v-card class="card1"
                                                v-bind:color="info.risk==='very low' ? 'teal accent-3' : 'blue lighten-5'">
                                            <div v-bind:class="info.risk==='very low' ? 'title white--text': 'black--text'">
                                                <h2>Very Low</h2></div>
                                            <div v-bind:class="info.risk==='very low' ? 'title white--text': 'black--text'">
                                                0-9 approximately
                                            </div>

                                            <div v-bind:class="info.risk==='very low' ? 'title white--text': 'black--text'">
                                                1 person in every 16 will develop diabetes
                                            </div>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 md2>



                                        <v-card v-bind:color="info.risk==='low' ? 'teal accent-3' : 'blue lighten-5'"
                                                class="card1">
                                             <span v-bind:class="info.risk==='low' ? 'title white--text': 'black--text'">Based on your results, you are at low risk for prediabetes. Keep up the good work!</span>
                                            <div v-bind:class="info.risk==='low' ? 'title white--text': 'black--text'">
                                                <h2>Low</h2></div>
                                            <div v-bind:class="info.risk==='low' ? 'title white--text': 'black--text'">
                                                10-19 approximately
                                            </div>

                                            <div v-bind:class="info.risk==='low' ? 'title white--text': 'black--text'">1
                                                person in every 6 will
                                                develop diabetes
                                            </div>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 md2>
                                        <v-card v-bind:color="info.risk==='moderate' ? 'orange darken-4' : 'blue lighten-5'"
                                                class="card1">
                                            <div v-bind:class="info.risk==='moderate' ? 'title white--text': 'black--text'">
                                                <h2>Moderate</h2></div>
                                            <div v-bind:class="info.risk==='moderate' ? 'title white--text': 'black--text'">
                                                20-36 approximately
                                            </div>
                                            <div v-bind:class="info.risk==='moderate' ? 'title white--text': 'black--text'">
                                                1 person in every 3 will develop diabetes
                                            </div>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 md3>
                                        <v-card v-bind:color="info.risk==='high' ? 'red darken-1 ' : 'blue lighten-5'"
                                                class="card1">
                                            <div v-bind:class="info.risk==='high' ? 'title  white--text': 'black--text'">
                                                <h2>High</h2></div>
                                            <div v-bind:class="info.risk==='high' ? ' title white--text': 'black--text'">
                                                37-46 approximately
                                            </div>
                                            <div v-bind:class="info.risk==='high' ? 'title white--text': 'black--text'">
                                                1 person in every 2 will develop diabetes
                                            </div>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 md3>
                                        <v-card v-bind:color="info.risk==='very high' ? 'red darken-1' : 'blue lighten-5'"
                                                class="card1">
                                            <div v-bind:class="info.risk==='very high' ? 'title white--text': 'black--text'">
                                                <h2>Very High</h2></div>
                                            <div v-bind:class="info.risk==='very high' ? 'title white--text': 'black--text'">
                                                Higher than 46 approximately
                                            </div>
                                            <div v-bind:class="info.risk==='very high' ? 'title white--text': 'black--text'">
                                                4 person in every 5 will develop diabetes
                                            </div>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card>

                            <v-card-actions>
                                <v-flex md4/>
                                <v-btn class="ma-2" outlined color="black" @click="dialog= false, step =1">Try Test
                                    again
                                </v-btn>
                            </v-card-actions>


                        </v-window-item>
                    </v-window>
                </material-card>
            </v-flex>

            <v-flex xs12 md4 align="start">
                <material-card class="card" v-if="step!==7">
                    <v-img class="img" :src=images()></v-img>
                    <v-card-text class="text-xs-center">
                        <h6 class="category text-gray font-weight-thin mb-3"></h6>
                        <h4 class="card-title font-weight-light"></h4>
                        <p class="card-description font-weight-light"><span class=" subtitle-1 blue--text">{{imageText()}}</span>
                        </p>
                    </v-card-text>
                </material-card>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 md8>
                <material-card>
                    <v-btn class="btn" :disabled="step === 1" color="primary" @click="step--">
                        Previous
                    </v-btn>

                    <v-btn class="btn"
                           :disabled="step === 7 || age === 0 || (waist === 0 && step === 3)  ||
                  (sistolicBP === 0 && step === 4) ||
                 (diastolicBP === 0 && step === 5) || (gender==='' && step===2) ||
                 (height === '' && step===6) || (weight === '' && step===6)"
                           color="primary"
                           depressed
                           @click="step++, step===7 ? Score(age,gender,height,weight,diastolicBP,sistolicBP,waist):null"
                    >
                        Next
                    </v-btn>

                    <v-btn class="btn" color="primary" href="/" @click="dialog = false">Close</v-btn>
                </material-card>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
    import SelectGender from "./SelectGender"
    import SelectManWaist from "./SelectManWaist"
    import SelectWomanWaist from "./SelectWomanWaist"
    import SystolicBloodPressure from "./SystolicBloodPressure"
    import DiastolicBloodPressure from "./DiastolicBloodPressure"
    import SelectHeight from "./SelectHeight"
    import SelectWeight from "./SelectWeight"
    import SelectAge from "./SelectAge"
    import axios from "axios"


    export default {
        components: {
            SelectGender,
            SelectManWaist,
            SelectWomanWaist,
            SystolicBloodPressure,
            DiastolicBloodPressure,
            SelectHeight,
            SelectWeight,
            SelectAge
        },
        data: () => ({
            step: 1,
            age: 0,
            gender: '',
            height: '',
            weight: '',
            diastolicBP: 0,
            sistolicBP: 0,
            waist: 0,
            dialog: false,
            info: '',
            ageImage: require('@/img/age.jpg')
        }),

        computed: {
            currentTitle() {

                switch (this.step) {
                    case 1:
                        return 'What is your age group?'
                    case 2:
                        return 'Your gender'
                    case 3:
                        return 'What is your Waist size in cm ?'
                    case 4:
                        return 'What is your Systolic Blood Pressure in mm Hg ?'
                    case 5:
                        return 'What is your Diastolic Blood Pressure in mm Hg ?'
                    case 6:
                        return 'About your Body Mass Index or BMI.'
                    default:
                        return ''
                }
            },
        },

        methods: {

            Score: function (age, gender, height, weight, diastolicBP, sialosticBP, waist) {
	//	    alert(process.env.VUE_APP_PRISQ_CALCULATOR_DNS +  '/score')
                axios
		    .get(process.env.VUE_APP_PRISQ_CALCULATOR_DNS +  '/score', {
                        params: {
                            age: this.age,
                            gender: this.gender,
                            diastolicBP: this.diastolicBP,
                            sistolicBP: this.sistolicBP,
                            height: this.height,
                            weight: this.weight,
                            waist: this.waist,

                        }
                    })
                    .then(response => (this.info = response.data))
                    .then(console.log(this.info))

            },
            images: function () {
                switch (this.step) {
                    case 1:
                        return require('@/img/age1.jpg')
                    case 2:
                        return require('@/img/gender1.jpg')
                    case 3:
                        return require('@/img/waist.jpg')
                    case 4:
                        return require('@/img/blood-pressure1.jpg')
                    case 5:
                        return require('@/img/blood-pressure1.jpg')
                    case 6:
                        return require('@/img/height-weight.jpg')
                    case 7:
                        return ''
                    default:
                        return 'asas'
                }
            },
            imageText: function () {
                switch (this.step) {
                    case 1:
                        return 'You are at a higher risk for prediabetes the older you are.'
                    case 2:
                        return 'Men are more likely than women to have undiagnosed diabetes; one reason may be that they are less likely to see their doctor regularly.'
                    case 3:
                        return 'To measure your waist size (circumference), place a tape measure around your bare abdomen just above your hipbone. Be sure that the tape is snug, but does not compress your skin, and is parallel to the floor. Relax, exhale, and measure your waist.'
                    case 4:
                        return 'Normal Systolic blood pressure is  120 mmHg or below'
                    case 5:
                        return 'Normal Diastolic blood pressure is  80 mmHg or below '
                    case 6:
                        return 'The combination of your weight and height lets us know your Body Mass Index or BMI. People with higher BMIs are at a higher risk'
                    default:
                        return ''
                }
            },
            setAge: function (value) {

                this.age = value
            },
            setGender: function (value) {
                this.gender = value
            },
            setdiastolicBP: function (value) {
                this.diastolicBP = value
            },
            setsistolicBP: function (value) {
                this.sistolicBP = value
            },
            setWeight: function (value) {
                this.weight = value
            },
            setHeight: function (value) {
                this.height = value
            },
            setWaist: function (value) {
                this.waist = value
            },
            getGender: function () {
                //alert(this.gender)
                return this.gender
            }
        },
    }
</script>

<style lang="css">
    .img {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .card {
        margin-top: 100px;
        margin-left: 30px;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .card1 {
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .btn {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
    }

</style>
